import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api from "../lib/api";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.error("Lien invalide");
      return;
    }
    if (password.length < 6) {
      toast.error("6 caractères minimum");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé ! Connectez-vous.");
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="reset-page">
      <div className="w-full max-w-md card-soft p-8 sm:p-10">
        <div className="flex justify-center mb-6">
          <img src="https://customer-assets.emergentagent.com/job_fundcollect-1/artifacts/z3sp2s14_logo-sen-cagnotte-1.png" alt="Sen Cagnotte" className="h-16 w-16 rounded-2xl object-cover" />
        </div>
        <h1 className="font-display text-3xl font-bold text-center mb-2">Nouveau mot de passe</h1>
        <p className="text-center text-muted-foreground mb-8 text-sm">Choisissez un nouveau mot de passe sécurisé.</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="password">Nouveau mot de passe</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="pl-10 h-11 rounded-xl" data-testid="reset-password" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full btn-gradient rounded-full h-11" data-testid="reset-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Mettre à jour"}
          </Button>
        </form>
        <p className="text-center text-sm text-muted-foreground mt-6">
          <Link to="/login" className="hover:text-foreground">Retour à la connexion</Link>
        </p>
      </div>
    </div>
  );
}
